import React from 'react';
import classnames from 'classnames';
import TextComponent from './TextComponent';

const Revision = (props) => {
  const {
    parameters,
    onChangeParameter,
    groupName,
    required,
    name,
    tooltip,
  } = props;
  const onChange = event => onChangeParameter('revision', event.target.value);
  return (
    <TextComponent
      label={props.label}
      name="revision"
      inputId={props.inputId}
      value={parameters[name] || ''}
      required={required}
      ignoreOnQuote={props.ignoreOnQuote}
      onChange={onChange}
      groupName={groupName}
      tooltip={tooltip}
      className={classnames('revision', props.className)}
      {...props} />
  );
};

Revision.defaultProps = {
  name: 'revision',
  required: true,
  ignoreOnQuote: true,
  inputId: 'revision',
  label: 'Revision',
};

export default Revision;
